import RequireAuth from '../Components/RequireAuth';
import { Routes, Route} from 'react-router-dom';
import ViewProfiles from './Profiles/Profiles';
import AddProfile from './Profiles/AddProfile';
import ViewProfile from './Profiles/Profile';

function Profiles({id, img}) {

  return (
      <Routes>
        <Route exact path='/' element={<ViewProfiles id={id} img={img}/>} />
        <Route exact path='/view/:id' element={<ViewProfile img={img}/>} />
        <Route element={<RequireAuth allowedRoles={[3, 4, 5]} />}>
          <Route exact path='/add' element={<AddProfile img={img}/>} />
        </Route>
      </Routes>
  )
}

export default Profiles